export default "__VITE_ASSET__Dtv5X$66__"